import { ImageOff, RefreshCw } from 'lucide-react';
import { useAdminFailedPhotos, useReprocessFailedPhoto } from 'app/javascript/queries/useAdmin';
import AdminPanel from 'app/javascript/components/admin/AdminPanel';
import { Button } from 'app/javascript/components/ui/button';
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from 'app/javascript/components/ui/table';
import { formatBrDate, formatBRDateTime } from 'app/javascript/utils/dates';

export default function FailedPhotosTable() {
  const { data, isLoading, isError } = useAdminFailedPhotos();
  const reprocess = useReprocessFailedPhoto();
  const photos = data ?? [];

  return (
    <AdminPanel
      isLoading={isLoading}
      isError={isError}
      isEmpty={photos.length === 0}
      emptyMessage="Nenhuma foto precisa de atenção."
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Foto</TableHead>
            <TableHead>Academia</TableHead>
            <TableHead>Data da aula</TableHead>
            <TableHead>Diagnóstico</TableHead>
            <TableHead>Enviada em</TableHead>
            <TableHead className="text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {photos.map((photo) => (
            <TableRow key={photo.id}>
              <TableCell>
                {photo.photo_url ? (
                  <img
                    src={photo.photo_url}
                    alt="Foto de check-in facial com problema de processamento"
                    className="h-10 w-10 rounded object-cover"
                  />
                ) : (
                  <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
                    <ImageOff className="h-4 w-4" />
                    foto removida
                  </span>
                )}
              </TableCell>
              <TableCell>{photo.company_name || '—'}</TableCell>
              <TableCell className="text-muted-foreground">
                {photo.class_date ? formatBrDate(photo.class_date) : '—'}
              </TableCell>
              <TableCell
                className={`max-w-md text-sm ${photo.stuck_processing ? 'text-amber-400' : 'text-red-400'}`}
              >
                {photo.stuck_processing
                  ? `Processamento sem atualização desde ${formatBRDateTime(photo.updated_at)}`
                  : photo.failure_reason || 'Falha sem motivo registrado'}
              </TableCell>
              <TableCell className="text-muted-foreground">
                {formatBRDateTime(photo.created_at)}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  size="sm"
                  variant="outline"
                  disabled={!photo.reprocessable || reprocess.isPending}
                  onClick={() => reprocess.mutate(photo.id)}
                >
                  <RefreshCw
                    className={`h-3.5 w-3.5 ${
                      reprocess.isPending && reprocess.variables === photo.id ? 'animate-spin' : ''
                    }`}
                  />
                  Reprocessar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {reprocess.isError && (
        <p className="p-3 text-sm text-red-400">{(reprocess.error as Error).message}</p>
      )}
    </AdminPanel>
  );
}
